import React from 'react';
import { select, text, boolean, number } from '@storybook/addon-knobs';
import Tag, { types as typesList } from 'carbon-components-react/lib/components/Tag';
import { action } from '@storybook/addon-actions';
import TimePicker from 'carbon-components-react/lib/components/TimePicker';
import TimePickerSelect from 'carbon-components-react/lib/components/TimePickerSelect';
import SelectItem from 'carbon-components-react/lib/components/SelectItem';
import TextArea from 'carbon-components-react/lib/components/TextArea';

const sizes = {
  'Extra large size (xl)': 'xl',
  'Default size': undefined,
  'Small size (sm)': 'sm',
};

const props = {
  timepicker: () => ({
    pattern: text(
      'Regular expression for the value (pattern in <TimePicker>)',
      '(1[012]|[1-9]):[0-5][0-9](\\s)?'
    ),
    placeholder: text(
      'Placeholder text (placeholder in <TimePicker>)',
      'hh:mm'
    ),
    disabled: boolean('Disabled (disabled in <TimePicker>)', false),
    light: boolean('Light variant (light in <TimePicker>)', false),
    labelText: text('Label text (labelText in <TimePicker>)', 'Select a time'),
    invalid: boolean(
      'Show form validation UI (invalid in <TimePicker>)',
      false
    ),
    invalidText: text(
      'Form validation UI content (invalidText in <TimePicker>)',
      'A valid value is required'
    ),
    maxLength: number('Maximum length (maxLength in <TimePicker>)', 5),
    size: select('Field size (size)', sizes, undefined) || undefined,
    onClick: action('onClick'),
    onChange: action('onChange'),
    onBlur: action('onBlur'),
  }),
  select: () => ({
    disabled: boolean('Disabled (disabled in <TimePickerSelect>)', false),
    labelText: text(
      'Label text (labelText in <TimePickerSelect>)',
      'Please select'
    ),
    iconDescription: text(
      'Trigger icon description (iconDescription in <TimePickerSelect>)',
      'open list of options'
    ),
  }),
};



 const TimeZone = () => {
  const selectProps = props.select();
  return (
    <TimePicker id="time-picker" {...props.timepicker()}>
      <TimePickerSelect id="time-picker-select-1" {...selectProps}>
        <SelectItem value="AM" text="AM" />
        <SelectItem value="PM" text="PM" />
      </TimePickerSelect>
      <TimePickerSelect id="time-picker-select-2" {...selectProps}>
        <SelectItem value="Time zone 1" text="Time zone 1" />
        <SelectItem value="Time zone 2" text="Time zone 2" />
      </TimePickerSelect>
    </TimePicker>
  );
};

  const filter = (param) => {
    return {
        type: select(
            'Tag type (type)',
            typesList.reduce(
              (acc, type) => ({
                ...acc,
                [`${type} (${type})`]: type,
              }),
              {
                Default: undefined,
              }
            )
          ),
          disabled: param.disabled,
          title: param.title,
        onClick: param.onClick,
        onClose: param.onClose,
      };
  }

   const TagComponent = (param) => (
    <Tag className= {param.className} type = {param.type} disabled = {param.disabled} title = {param.title}  onClose ={param.onClose} onClick={param.onClick}>
        {param.children}
    </Tag>
  );
 
  const TextAreaProps = (props) => ({
    className: 'some-class',
    disabled: boolean('Disabled (disabled)', false),
    light: boolean('Light variant (light)', false),
    hideLabel: boolean('No label (hideLabel)', false),
    labelText: text('Label text (labelText)', 'Work Notes'),
    invalid: boolean('Show form validation UI (invalid)', false),
    invalidText: text(
      'Content of form validation UI (invalidText)',
      'A valid value is required'
    ),
   // helperText: text('Helper text (helperText)', 'Optional helper text.'),
    placeholder: text('Placeholder text (placeholder)', 'Placeholder text.'),
    id: 'test2',
    cols: number('Columns (columns)', 30),
    rows: number('Rows (rows)', 4),
    onChange: action('onChange'),
    //onClick: action('onClick'),
  });
  
   const TextAreas = () => <TextArea {...TextAreaProps()} />
export{TextAreas, TagComponent};
  export default TimeZone;
